// RITA-1552 — Rücklauf der Vertragserstellung: Scan des unterschriebenen Vertrags hochladen (Backend:
// uploadSignedContract, nur Super-Admins; Skizze Rücklauf, Bild C). Die Datei geht als Upload (multipart) über den
// aktiven createUploadLink (components/ErrorMessage/ErrorMessage.tsx). Die Antwort gleicht der beim Drucken: der neue
// Eintrag „scan_uploaded“ (mit contract_entry_id = Vertrag), die Datei des Scans und die Berater-UUID, mit der die
// Liste „Dokumente“ neu geladen wird. Die Operation ist benannt, weil die Tests sie am Namen erkennen.
// Fehlercodes des Servers: NOT_FOUND, NO_USER, INVALID_ENTRY, EMPTY_FILE, NOT_PDF, FILE_TOO_LARGE, STORAGE_FAILED
// (Nutzertexte: scanFehlertextFuerCode in services/vertragsdruckTexte.ts).
import { gql } from '@apollo/client';
import { Druckantwort, ERGEBNIS_FELDER } from './vertragsdruck';

export interface ScanVariablen {
  /** Beraternummer (agent.agent_id). */
  agent_id: number;
  /** Druck-Eintrag mit Vertrag, zu dem der Scan gehört (auch ein ersetzter Vertrag). */
  entry_id: number;
  /** Die gewählte PDF (höchstens 20 MB). */
  file: File;
}

export interface ScanAntwort {
  uploadSignedContract: Druckantwort;
}

export const UPLOAD_SCAN = gql`
  mutation uploadScan($agent_id: Int!, $entry_id: Int!, $file: Upload!) {
    uploadSignedContract(agent_id: $agent_id, entry_id: $entry_id, file: $file) {
      ${ERGEBNIS_FELDER}
    }
  }
`;
